import { render } from "./Menu.vue?vue&type=template&id=d213400e&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=d213400e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d213400e"]])

export default __exports__